export interface Campaign {
    campaign_name: string
    campaign_resource_name: string
    status: CampaignsUpdateStatus
}

export interface Body {
    domain_id: number
    campaigns?: Campaign[]
    spend_points?: { x: number; y: number; dotted?: boolean }[]
    status: CheckBudgetResults
    monthly_budget: string
    monthly_budget_raw: number
    monthly_spend: string
    monthly_spend_raw: number
    acceptable_variance: string
    acceptable_variance_raw: number
    template_name: string
    date: string
    enable_date?: string
    time_zone: string
    date_above_budget_projection?: string
    date_above_budget_projection_raw?: number
    days_until_pause?: number
    is_first_of_month?: boolean
}

export enum CampaignsUpdateStatus {
    PAUSED = 0,
    ENABLED = 1,
    FAILED_PAUSE = 2,
    FAILED_ENABLE = 3,
    NO_ACTION = 4,
    NO_ACTION_VIDEO = 5,
}

export enum CheckBudgetResults {
    CAMPAIGNS_HAVE_BEEN_PAUSED = 0,
    CAMPAIGNS_HAVE_BEEN_ENABLED = 1,
    RISK_OF_OVER_BUDGET = 2,
    LOST_WRITE_ACCESS = 3,
    NO_ACTION = 4,
}

export enum EmptyStates {
    CampaignsPaused = 'campaigns_paused',
    ZeroSpend = 'zero_spend',
    FirstImps = 'first_imps',
    CompletedImps = 'completed_imps',
    LostWriteAccess = 'lost_write_access',
    NotEmptyState = 'not_empty_state',
}

export interface EmailData {
    domain_name: string
    tag_name: string
    account_color: string
    template_name: string
    monthly_spend: string
    monthly_budget: string
    acceptable_variance: string
    date_above_budget_projection?: string
    time_zone: string
    campaigns?: Campaign[]
    date: string
    enable_date?: string
    alert_id: string
    title: string

    // subject: string
    // title_url: string
    // alert_settings_url: string
}
